import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Helmet} from 'react-helmet';
import { withRouter } from 'react-router';
import { pdf as PDFRenderer }from '@react-pdf/renderer';

import Box from '../components/common/Box';
import BulkCSVExport from '../components/common/BulkCSVExport';
import CatalogOverview from '../components/widgets/catalog/CatalogOverview';
import VendorsWidget from '../components/pages/home/VendorsWidget';
import TerritoriesWidget from '../components/pages/home/TerritoriesWidget';
import EntitiesList from '../components/pages/home/EntitiesList';
import FilterEntityList from '../components/widgets/entityFilter/EntitiesList';
import store from '../helpers/store'
import SearchWidget from '../components/pages/home/SearchWidget';
import StatementTotals from '../components/pages/home/StatementTotals';
import { imprintsActions } from '../data/actions/imprints';
import { artistsActions } from '../data/actions/artists';
import { productsActions } from '../data/actions/products';
import { projectsActions } from '../data/actions/projects';
import { tracksActions } from '../data/actions/tracks';
import { statsActions } from '../data/actions/stats';
import { filterActions } from '../data/actions/filter';
import CSV from '../helpers/CSVExport';
import SharePage from '../components/pages/sharedPages/SharePage';
import PDFDocument from '../components/pages/home/PDF';
import TransactionTypes from '../components/common/Stats/TransactionTypes';

const downloadSvg = require('!svg-inline-loader!../../public/img/download.svg');

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.searchResult = this.searchResult.bind(this);
        this.exportToCsv = this.exportToCsv.bind(this);
        this.exportToPdf = this.exportToPdf.bind(this);
        this.loadAllData = this.loadAllData.bind(this);
    }

    searchResult(item) {
        /*
        if(item.entity == 'imprints') {
            this.props.setFilter(item.entity, [item]);
            this.props.history.push(`/catalog/${item.entity}`);
        }
        else {
        */
            this.props.history.push(`/${item.entity}/${item.id}`);
        //}

    }

    exportToCsv(){
      const {
        imprints,
        artists,
        products,
        projects,
        tracks,
        stats
      } = this.props;
      const id = 0;

      const data = [
                    { statement_totals: stats.statementTotals},        
                    {top_imprints: imprints.top[id].data},
                    {top_artists: artists.top[id].data},
                    {top_projects: projects.top[id].data},
                    {top_products: products.top[id].data},
                    {top_tracks: tracks.top[id].data},
                    {territories: stats.topTerritory.table},
                    {top_plaforms: stats.vendors[id].data.table},

      ];
      
      

      const filename = CSV.CSVHeader('overview', null, this.props.filter.global);
      CSV.CSVBulkExport(data, filename);

    }
    
    getPdfData() {
        const reportTitle = 'Overview',
            { imprints, artists, products, tracks, stats } = this.props;
        const baseID = 0;    
        const imageIDs = [
              'top_territories_pie_chart',
              'top_vendors_pie_chart',
        ];
        let images = {};
        for (let imageID of imageIDs){
            let image = document.getElementById(imageID);
            if(image)
                images[imageID] = image.toDataURL("image/jpeg,1.0"); 
        }
        
        let vendorTableData = [];

        if (this.props.stats.vendors)
            vendorTableData = this.props.stats.vendors[baseID].data.table;

        const tables = {
            imprints: imprints.top[baseID].data,
            artists: artists.top[baseID].data,
            products: products.top[baseID].data,
            tracks: tracks.top[baseID].data,
            territories: stats.topTerritory.table,
            vendorsTable: vendorTableData,
            statementTotals: stats.statementTotals
        };
        return { reportTitle, images, tables, globalFilter: this.props.filter.global };
    }
    
    exportToPdf() {
        const data = PDFRenderer(<PDFDocument data={this.getPdfData()} />);
        data.toBlob()
        .then(blob=>{
            const fileURL = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = fileURL;
            link.download = `${CSV.CSVHeader('overview', null, this.props.filter.global)}.pdf`;
            link.click();
        });
    }
    loadAllData(){
        const datasets = ['imprints', 'artists', 'projects', 'products', 'tracks', 'top_territories', 'vendors'];
        const dataCalls = datasets.map(dataset=>this.props.loadAllDataCall(dataset));
        Promise.all(dataCalls).then(results=>console.log('done'));
    }

    renderFilterEntities() {
        const currentFilter = store.get('userEntityFilter') || {};
        const include = {};
        const exclude = {};

        Object.keys(currentFilter).forEach(key => {
            if (key.startsWith('exclude_')) {
                exclude[key] = currentFilter[key];
            } else {
                include[key] = currentFilter[key];
            }
        });

        const hasInclude = Object.values(include).some(arr => arr.length);
        const hasExclude = Object.values(exclude).some(arr => arr.length);

        return (
            <div className="filter-search-list home-filter-results-block">
                {hasInclude && (
                    <React.Fragment>
                        <h5 className="filter-search-list-title">Inclusions</h5>
                        <div className='filter-search-list-total'>
                            {Object.keys(include).map(type =>
                                include[type].length ? (
                                    <FilterEntityList
                                        key={type}
                                        pageFilterObjects={this.pageFilterObjects}
                                        entities={include[type]}
                                        type={type}
                                        noIcon={true}
                                    />
                                ) : null
                            )}
                        </div>
                    </React.Fragment>
                )}

                {hasExclude && (
                    <React.Fragment>
                        <h5 className="filter-search-list-title">Exclusions</h5>
                        <div className='filter-search-list-total'>
                            {Object.keys(exclude).map(type =>
                                exclude[type].length ? (
                                    <FilterEntityList
                                        key={type}
                                        pageFilterObjects={this.pageFilterObjects}
                                        entities={exclude[type]}
                                        type={type}
                                        noIcon={true}
                                    />
                                ) : null
                            )}
                        </div>
                    </React.Fragment>
                )}

            </div>
        );
    }

    render() {
        const { sharedMode, filter } = this.props;
        const { entityFilterSet, previousPeriodSet: prevPeriod } = this.props.filter.global;


        return (
            <div className="homepage">
                
                <div className="container">
                
                  <div className="download-page download-page--mt">
                    <span>Export the data</span>
                    {sharedMode && <a key="download" title="Download entire page" onClick={this.exportToCsv} className="chart-icon download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />}
                    {!sharedMode && <SharePage entity="" id="" module="home" exportToCsv={this.exportToCsv} exportToPdf={this.exportToPdf} CSVEntities={["top_imprints", "top_artists", "top_products", "top_projects", "top_tracks", "top_territories", "top_vendors"]}  flatCSVExport={true} />}
                  </div>
                 
                </div>
                 
                {/*<div className="container container-small transparent">
                    <SearchWidget searchResult={this.searchResult}/>
                </div>*/}
                {!entityFilterSet && <div className="container">
	            	<StatementTotals />
	            </div>}
                
                {entityFilterSet && <div className="container home-entity-filter">
                    <h2 className="ibox-title__title">Entity Filters</h2>
                    {this.renderFilterEntities()}
                </div>}

                {entityFilterSet && <div className="container">
                  <TransactionTypes entity="mixed" id="all" />
                </div>}

                
                <div className="container">
                	<EntitiesList title="Top Labels" entity="imprints" externalLinks={!sharedMode} prevPeriod={prevPeriod} />
                </div>
                
                <div className="container">
                    <div className={`${!prevPeriod ? "top-tables-container" : ""}`}>
                        <EntitiesList title="Top Artists" entity="artists" includeTimeseries={true} externalLinks={!sharedMode} prevPeriod={prevPeriod} />
                        <EntitiesList title="Top Projects" entity="projects" includeTimeseries={true} externalLinks={!sharedMode} prevPeriod={prevPeriod} />
                        <EntitiesList title="Top Products" entity="products" includeTimeseries={true} externalLinks={!sharedMode} prevPeriod={prevPeriod} />
                        <EntitiesList title="Top Tracks" entity="tracks" includeTimeseries={true} externalLinks={!sharedMode} prevPeriod={prevPeriod} />
                    </div>
                </div>
                
                <div className="container">
                    <TerritoriesWidget prevPeriod={prevPeriod} />
                </div>

                <div className="container">
                    <VendorsWidget prevPeriod={prevPeriod} />
                </div>
                <Helmet>
                    <title>Overview</title>
                </Helmet>

            </div>
        )
    }

}


function mapStateToProps(state) {
  const {
    imprints,
    artists,
    products,
    projects,
    tracks,
    stats,
    filter
  } = state;

  return {
    imprints,
    artists,
    products,
    projects,
    tracks,
    stats,
    filter
  }
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        setFilter: (entity, filter) => {
            return dispatch(filterActions.setEntityFilter(entity, filter));
        },
        loadAllDataCall: (entity) => {
            switch(entity) {
                case 'imprints':
                    return dispatch(imprintsActions.forceLoadAllData(true));            
                case 'artists':
                    return dispatch(artistsActions.forceLoadAllData(true));
                case 'projects':
                    return dispatch(projectsActions.forceLoadAllData(true));
                case 'products':
                    return dispatch(productsActions.forceLoadAllData(true));
                case 'tracks':
                    return dispatch(tracksActions.forceLoadAllData(true));
                case 'top_territories':
                    return dispatch(statsActions.forceLoadAllTopTerritoriesData(true));
                case 'territories':
                    return dispatch(statsActions.forceLoadAllTerritoriesData(true));                                
                case 'vendors':
                    return dispatch(statsActions.forceLoadAllVendorsData(true));            
                    
            }
            
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home))
